/* OverstockCasters app: scroll-reveal, watchlist (Save) + drawer, recently-viewed, compare. */
(function(){
  var d=document, w=window;
  try{ d.documentElement.classList.add('osc-js'); }catch(e){}
  function ready(fn){ if(d.readyState!=='loading') fn(); else d.addEventListener('DOMContentLoaded',fn); }
  function esc(s){ return (s||'').replace(/"/g,'&quot;'); }

  /* ---------- scroll reveal ---------- */
  function reveal(){
    var els=[].slice.call(d.querySelectorAll('.osc-reveal'));
    if(!els.length) return;
    if('IntersectionObserver' in w){
      var io=new IntersectionObserver(function(ents){ ents.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } }); },{rootMargin:'0px 0px -7% 0px', threshold:0.04});
      els.forEach(function(el){ io.observe(el); });
    } else { els.forEach(function(el){ el.classList.add('is-in'); }); }
    setTimeout(function(){ els.forEach(function(el){ el.classList.add('is-in'); }); }, 1800);
  }

  /* ---------- watchlist (Save) ---------- */
  function getW(){ try{ return JSON.parse(localStorage.getItem('osc_watch')||'[]'); }catch(e){ return []; } }
  function setW(a){ try{ localStorage.setItem('osc_watch', JSON.stringify(a)); }catch(e){} }
  function paintW(){
    var arr=getW(), n=arr.length, on={}; arr.forEach(function(x){ on[x.h]=1; });
    [].forEach.call(d.querySelectorAll('[data-watch-count]'), function(el){ el.textContent=n; el.classList.toggle('is-empty', n===0); });
    [].forEach.call(d.querySelectorAll('.osc-save'), function(b){ b.classList.toggle('is-on', !!on[b.getAttribute('data-handle')]); });
  }
  function renderWatch(){
    var box=d.querySelector('[data-watchlist]'); if(!box) return; var arr=getW();
    if(!arr.length){ box.innerHTML='<p class="osc-drawer__empty">No saved lots yet.<br>Tap the heart on any listing to save it here.</p>'; return; }
    box.innerHTML=arr.map(function(x){
      return '<div class="osc-witem"><a class="osc-witem__img" href="'+x.u+'">'+(x.img?'<img src="'+x.img+'" alt="" loading="lazy">':'<span class="osc-witem__ph"></span>')+'</a>'+
        '<div class="osc-witem__b"><a href="'+x.u+'" class="osc-witem__t">'+x.t+'</a><div class="osc-witem__p">'+(x.p||'')+'</div>'+
        '<button type="button" class="osc-witem__rm" data-rm="'+esc(x.h)+'">Remove</button></div></div>';
    }).join('');
  }
  function initWatch(){
    paintW();
    d.addEventListener('click', function(e){
      var b=e.target.closest('.osc-save'); if(!b) return;
      e.preventDefault(); e.stopPropagation();
      var h=b.getAttribute('data-handle'); if(!h) return;
      var arr=getW(), i=-1; arr.forEach(function(x,ix){ if(x.h===h) i=ix; });
      if(i>-1){ arr.splice(i,1); } else { arr.push({ h:h, t:b.getAttribute('data-title')||'', u:b.getAttribute('data-url')||'', p:b.getAttribute('data-price')||'', img:b.getAttribute('data-img')||'' }); }
      setW(arr); paintW(); renderWatch();
      b.classList.add('osc-save--pop'); setTimeout(function(){ b.classList.remove('osc-save--pop'); }, 240);
    });
    w.addEventListener('storage', function(){ paintW(); renderWatch(); });
  }
  function initDrawer(){
    var dr=d.getElementById('oscWatchDrawer'), btn=d.querySelector('[data-watch-toggle]'), ov=d.getElementById('oscDrawerOv'); if(!dr) return;
    function open(){ renderWatch(); dr.classList.add('is-open'); if(ov) ov.classList.add('is-open'); }
    function close(){ dr.classList.remove('is-open'); if(ov) ov.classList.remove('is-open'); }
    if(btn) btn.addEventListener('click', function(e){ e.preventDefault(); dr.classList.contains('is-open') ? close() : open(); });
    if(ov) ov.addEventListener('click', close);
    dr.addEventListener('click', function(e){ if(e.target.closest('[data-close]')){ close(); return; } var rm=e.target.closest('[data-rm]'); if(rm){ var h=rm.getAttribute('data-rm'); setW(getW().filter(function(x){ return x.h!==h; })); paintW(); renderWatch(); } });
  }

  /* ---------- recently viewed ---------- */
  function getR(){ try{ return JSON.parse(localStorage.getItem('osc_recent')||'[]'); }catch(e){ return []; } }
  function pushRecent(){
    if(!w.oscProduct || !w.oscProduct.h) return;
    var arr=getR().filter(function(x){ return x.h!==w.oscProduct.h; });
    arr.unshift(w.oscProduct); arr=arr.slice(0,12);
    try{ localStorage.setItem('osc_recent', JSON.stringify(arr)); }catch(e){}
  }
  function renderRecent(){
    var box=d.querySelector('[data-recent]'); if(!box) return;
    var arr=getR(); if(w.oscProduct){ arr=arr.filter(function(x){ return x.h!==w.oscProduct.h; }); }
    if(arr.length<2){ return; }
    box.innerHTML=arr.slice(0,8).map(function(x){
      return '<a class="osc-rcard" href="'+x.u+'"><span class="osc-rcard__img">'+(x.img?'<img src="'+x.img+'" alt="" loading="lazy">':'<span class="osc-witem__ph"></span>')+'</span><span class="osc-rcard__t">'+x.t+'</span><span class="osc-rcard__p">'+(x.p||'')+'</span></a>';
    }).join('');
    var sec=d.querySelector('[data-recent-sec]'); if(sec) sec.hidden=false;
  }

  /* ---------- compare ---------- */
  var cmp=[];
  var LABELS=[['p','Price'],['save','Savings'],['type','Caster type'],['dia','Wheel size'],['cap','Capacity'],['mat','Material'],['lot','Lot type'],['cond','Condition'],['brand','Brand'],['state','Ships from'],['freight','Freight']];
  function fmt(k,v){ if(!v) return '&mdash;'; if(k==='save') return v+'% off'; if(k==='cap') return v+' lb ea'; if(k==='freight') return v.replace(/\b\w/g,function(c){return c.toUpperCase();}); return v.replace(/\b\w/g,function(c){return c.toUpperCase();}); }
  function cardItem(card){
    var sv=card.querySelector('.osc-save')||{}; var dd=card.dataset||{}; var sd=(sv.dataset||{});
    return { h:sd.handle||dd.type+Math.random(), t:sd.title||'', u:sd.url||'#', p:sd.price||'', img:sd.img||'',
      type:dd.type,dia:dd.dia,cap:dd.cap,mat:dd.mat,cond:dd.cond,lot:dd.lot,brand:dd.brand,state:dd.state,save:dd.save,freight:dd.freight };
  }
  function paintCmpChecks(){ var on={}; cmp.forEach(function(x){ on[x.h]=1; }); [].forEach.call(d.querySelectorAll('[data-cmp]'), function(cb){ var card=cb.closest('.osc-deal'); var sv=card&&card.querySelector('.osc-save'); var h=sv&&sv.getAttribute('data-handle'); cb.checked=!!on[h]; }); }
  function renderBar(){
    var bar=d.getElementById('oscCmpBar'); if(!bar) return;
    bar.classList.toggle('is-on', cmp.length>0);
    var items=bar.querySelector('[data-cmp-items]'); var cnt=bar.querySelector('[data-cmp-count]'); if(cnt) cnt.textContent=cmp.length;
    if(items) items.innerHTML=cmp.map(function(x){ return '<span class="osc-cmpbar__chip">'+(x.img?'<img src="'+x.img+'" alt="">':'')+'<button type="button" data-cmp-rm="'+esc(x.h)+'" aria-label="Remove">&times;</button></span>'; }).join('');
  }
  function openCmp(){
    var m=d.getElementById('oscCmpModal'); if(!m||!cmp.length) return;
    var head='<th></th>'+cmp.map(function(x){ return '<th><a href="'+x.u+'"><span class="osc-cmpt__img">'+(x.img?'<img src="'+x.img+'" alt="">':'')+'</span><span class="osc-cmpt__t">'+x.t+'</span></a><div class="osc-cmpt__p">'+(x.p||'')+'</div></th>'; }).join('');
    var rows=LABELS.filter(function(l){return l[0]!=='p';}).map(function(l){
      return '<tr><td class="osc-cmpt__lbl">'+l[1]+'</td>'+cmp.map(function(x){ return '<td>'+fmt(l[0], x[l[0]])+'</td>'; }).join('')+'</tr>';
    }).join('');
    m.querySelector('[data-cmp-table]').innerHTML='<table class="osc-cmpt"><thead><tr>'+head+'</tr></thead><tbody>'+rows+'</tbody></table>';
    m.classList.add('is-open');
  }
  function initCompare(){
    d.addEventListener('change', function(e){
      var cb=e.target.closest('[data-cmp]'); if(!cb) return;
      var card=cb.closest('.osc-deal'); if(!card) return;
      var it=cardItem(card);
      if(cb.checked){ if(cmp.length>=4){ cb.checked=false; return; } if(!cmp.some(function(x){return x.h===it.h;})) cmp.push(it); }
      else { cmp=cmp.filter(function(x){ return x.h!==it.h; }); }
      renderBar();
    });
    var bar=d.getElementById('oscCmpBar');
    if(bar){
      bar.addEventListener('click', function(e){
        if(e.target.closest('[data-cmp-open]')) openCmp();
        if(e.target.closest('[data-cmp-clear]')){ cmp=[]; renderBar(); paintCmpChecks(); }
        var rm=e.target.closest('[data-cmp-rm]'); if(rm){ var h=rm.getAttribute('data-cmp-rm'); cmp=cmp.filter(function(x){return x.h!==h;}); renderBar(); paintCmpChecks(); }
      });
    }
    var m=d.getElementById('oscCmpModal');
    if(m){ m.addEventListener('click', function(e){ if(e.target===m || e.target.closest('[data-cmp-close]')) m.classList.remove('is-open'); }); }
  }

  /* ---------- sticky PDP buy bar ---------- */
  function initStickyBuy(){
    var bar=d.getElementById('oscStickyBuy'); if(!bar) return;
    var cta=d.querySelector('.osc-cta-stack'); if(!cta || !('IntersectionObserver' in w)) return;
    var io=new IntersectionObserver(function(ents){ ents.forEach(function(e){
      var past=!e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past); bar.setAttribute('aria-hidden', past?'false':'true');
    }); },{ threshold:0 });
    io.observe(cta);
  }

  /* ---------- count-up stats ---------- */
  function initCountup(){
    var els=[].slice.call(d.querySelectorAll('.osc-cu')); if(!els.length) return;
    function run(el){ var to=parseFloat(el.getAttribute('data-to'))||0, dur=1100, t0=null;
      function step(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/dur,1), e=1-Math.pow(1-p,3); el.textContent=Math.round(to*e); if(p<1) requestAnimationFrame(step); else el.textContent=to; }
      requestAnimationFrame(step); }
    if('IntersectionObserver' in w){ var io=new IntersectionObserver(function(ents){ ents.forEach(function(x){ if(x.isIntersecting){ run(x.target); io.unobserve(x.target); } }); },{threshold:.4}); els.forEach(function(el){ io.observe(el); }); }
    else els.forEach(run);
  }

  /* ---------- quick view ---------- */
  function initQuickView(){
    var m=d.getElementById('oscQuickModal'); if(!m) return; var box=m.querySelector('[data-qv-body]');
    var ROWS=[['cap','Load capacity',function(v){return v+' lb each';}],['dia','Wheel size',null],['type','Caster type',null],['mat','Material',null],['cond','Condition',null],['lot','Lot type',null],['brand','Brand',null],['state','Ships from',function(v){return v.toUpperCase();}],['freight','Freight',null]];
    function tc(s){ return (s||'').replace(/\b\w/g,function(c){return c.toUpperCase();}); }
    d.addEventListener('click', function(e){
      var btn=e.target.closest('[data-quickview]');
      if(btn){
        e.preventDefault(); e.stopPropagation();
        var card=btn.closest('.osc-deal'); if(!card) return;
        var sv=card.querySelector('.osc-save'); var sd=(sv&&sv.dataset)||{}; var dd=card.dataset||{};
        var rows=ROWS.map(function(r){ var v=dd[r[0]]; if(!v) return ''; return '<tr><td>'+r[1]+'</td><td>'+(r[2]?r[2](v):tc(v))+'</td></tr>'; }).join('');
        var off=dd.save?'<span class="osc-qv__off">'+dd.save+'% off</span>':'';
        box.innerHTML='<div class="osc-qv__head"><div class="osc-qv__media">'+(sd.img?'<img src="'+sd.img+'" alt="">':'<span class="osc-qv__ph"></span>')+'</div><div class="osc-qv__info"><h3>'+(sd.title||'')+'</h3><div class="osc-qv__price">'+(sd.price||'')+off+'</div><table class="osc-qv__spec"><tbody>'+rows+'</tbody></table><a class="osc-btn osc-btn--primary osc-btn--block" href="'+(sd.url||'#')+'">View Full Listing &rarr;</a></div></div>';
        m.classList.add('is-open'); return;
      }
      if(e.target===m || e.target.closest('[data-qv-close]')) m.classList.remove('is-open');
    });
  }

  ready(function(){ reveal(); initWatch(); initDrawer(); pushRecent(); renderRecent(); initCompare(); initStickyBuy(); initCountup(); initQuickView(); });
})();
